import {LessIcon} from "../../assets/icons";
import React from "react";
import {useSelector} from "react-redux";
import {menuSelector} from "../../redux/slices/menuSlice";
import {useNavigate} from "react-router-dom";


const SidebarPanel = ({setIsOpenSidebar}) => {

    const menu = useSelector(menuSelector);
    const navigate = useNavigate();
    const [selectItems, setSelectItems] = React.useState([]);

    const nav = (link) => {
        if (window.innerWidth <= 1023) {
            setIsOpenSidebar(false);
        }
        navigate(link);
    }

    const openSubList = (i) => {
        let items = selectItems;
        if (items.includes(i)) {
            items.splice(items.indexOf(i), 1);
        } else {
            items.push(i);
        }
        setSelectItems(items);
    }

    const acPanelStyle = {maxHeight: 0, opacity: 0, transition: 'max-height 0.3s ease, opacity 0.3s ease'};
    const acPanelStyleShow = {maxHeight: '1000px', opacity: 1, transition: 'max-height 0.3s ease, opacity 0.3s ease'};
    const spPanelHidden = {display: 'none'}

    return (
        <div className="sidebar-panel mob-hidden">
            <div className="flex h-full grow flex-col bg-white pl-[var(--main-sidebar-width)] dark:bg-navy-750">
                <div className="flex h-18 w-full items-center justify-between pl-4 pr-1">
                    <p className="text-base tracking-wider text-slate-800 dark:text-navy-100">
                        {menu.title}
                    </p>
                    <button onClick={setIsOpenSidebar} className="sidebar-close btn h-7 w-7 rounded-full p-0 text-primary hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:text-accent-light/80 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25 xl:hidden">
                        <LessIcon />
                    </button>
                </div>

                <div className="nav-wrapper h-[calc(100%-4.5rem)] overflow-x-hidden pb-6">
                    <ul className="flex flex-1 flex-col px-4 font-inter">
                        {
                            menu.items && menu.items.map((item, index) =>
                                <li key={index}>
                                    <button onClick={() => {openSubList(index); nav(item.link)}} className="nav-link flex relative pr-8 text-left justify-between items-center w-full py-2 text-base tracking-wide outline-none transition-colors duration-300 ease-in-out text-slate-600 hover:text-primary dark:text-navy-200 dark:hover:text-navy-50">
                                        {item.title} { item.count > 0 && <span style={{position: 'absolute', right: '0', top: '0.5rem'}}>({item.count})</span> }
                                    </button>
                                    {
                                        item.items &&
                                        <ul className="ac-panel" style={selectItems.includes(index) ? acPanelStyleShow : acPanelStyle}>
                                            {
                                                item.items.map((subitem, subindex) => <li key={subindex} style={{position: 'relative'}}>
                                                    <button onClick={() => nav(subitem.link)} className="w-full nav-link relative flex text-left items-center justify-between p-2 text-xs+ tracking-wide outline-none transition-[color,padding-left] duration-300 ease-in-out hover:pl-4">
                                                        <div className="flex items-center space-x-2 hover:text-primary">
                                                            <div className="h-1.5 w-1.5 rounded-full border border-current opacity-40"></div>
                                                            <span className={"flex w-full items-center justify-between"} style={{marginRight: '1rem'}}>
                                                                {subitem.title}
                                                                { subitem.count > 0 && <span style={{position: 'absolute', right: '0', top: '0.5rem'}}>({subitem.count})</span> }
                                                            </span>
                                                        </div>
                                                    </button>
                                                </li>)
                                            }
                                        </ul>

                                    }
                                </li>
                            )
                        }
                        {/*<li>
                                    <a href="/" className="nav-link flex py-2 text-xs+ tracking-wide outline-none transition-colors duration-300 ease-in-out font-medium text-primary dark:text-accent-light">
                                        CRM Analytics
                                    </a>
                                </li>*/}
                    </ul>
                    {/*<div className="mx-4 my-3 h-px bg-slate-200 dark:bg-navy-500"></div>
                            <ul className="flex flex-1 flex-col px-4 font-inter">
                                <li className="ac nav-parent [&.is-active_.ac-trigger]:font-semibold [&.is-active_.ac-trigger]:text-slate-800 dark:[&.is-active_.ac-trigger]:text-navy-50 [&.is-active_svg]:rotate-90">
                                    <button className="ac-trigger flex w-full items-center justify-between py-2 text-xs+ tracking-wide text-slate-600 outline-none transition-[color,padding-left] duration-300 ease-in-out hover:text-slate-800 dark:text-navy-200 dark:hover:text-navy-50">
                                        <span>Cryptocurrency</span>
                                        <GreaterIcon />
                                    </button>
                                    <ul className="ac-panel">
                                        <li>
                                            <a href="/" className="nav-link flex items-center justify-between p-2 text-xs+ tracking-wide outline-none transition-[color,padding-left] duration-300 ease-in-out hover:pl-4">
                                                <div className="flex items-center space-x-2">
                                                    <div className="h-1.5 w-1.5 rounded-full border border-current opacity-40"></div>
                                                    <span>Cryptocurrency v1</span>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>*/}
                </div>
            </div>
        </div>
    )

}

export default SidebarPanel;
